import { useState, useEffect } from "react";
import { api } from "../../utils/api.js";
import { ENDPOINTS as E } from "../../utils/endpoints.js";
import { RESPONDS_REPORT_HANDLE, MICRO_RESPONDS } from "../../consts.js";

const Reports = ({ needReset, callReset }) => {
  const [ink, setInk] = useState(NaN);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("23:59");
  const [isNeedSetEnd, SetNeedEnd] = useState(false);
  const [isNeedSetStart, SetNeedStart] = useState(false);
  const [isPopupOpened, SetPopupOpened] = useState(false);
  const [report, setReport] = useState(null);
  const [reportType, setReportType] = useState("");
  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    if (needReset) {
      setReportType("");
    }
  }, [needReset]);

  const saveFile = (content, filename, contentType = "text/plain") => {
    const blob = new Blob([content], { type: contentType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const formatReportToText = (data, type) => {
    if (type !== "avito") {
      const typeText =
        type === "avito"
          ? "по откликам из авито"
          : type === "wa"
          ? "о откликах отправленных в мессенджер"
          : "о откликах отправленных на почту";
      const start = startDate
        ? ` с ${startTime} ${startDate}`
        : " с самого начала";
      const end = endDate
        ? ` по ${endTime} ${endDate}`
        : " по настоящее время:";

      let content = "Отчёт " + typeText + start + end + "\n\n";

      const { total, agg, src, responds } = data;

      if (!total) {
        content += "За выбранный период не было отправлено ни одного отклика\n";
        content +=
          "Проверьте правильность введенных данных, возможно была допущена ошибка";
        return content;
      }

      content += `Всего отправлено ${total} откликов. По вакансиям:\n`;

      Object.entries(agg).forEach(([key, value]) => {
        content += `\t${key}: ${value}\n`;
      });

      content += "\n";

      if (Object.keys(src).length === 1) {
        content += `Все отклики пришли из ${Object.keys(src)[0]}\n`;
      } else {
        const sources = Object.entries(src)
          .map(([source, count]) => `${count} откликов из ${source}`)
          .join(", ");
        content += sources + "\n";
      }

      content += "\nДетально:\n";

      responds.forEach((resp, index) => {
        content += `Отклик ${index + 1}:\n`;
        Object.entries(resp).forEach(([key, value]) => {
          if (RESPONDS_REPORT_HANDLE[key] && value && value !== "") {
            content += `\t${RESPONDS_REPORT_HANDLE[key]}: ${value}\n`;
            /* ["sent_ts", "ts"].includes(key)
                ? new Date(value).toLocaleString()
                : value
            }\n`; */
          }
        });
        content += "\n";
      });
      return content;
    }
    return null;
  };

  const createHeading = () => {
    const isInk = !isNaN(ink) ? ` по ИНК - ${ink}` : "";
    const type =
      reportType === "avito"
        ? "по откликам из авито"
        : reportType === "sources"
        ? "по источникам откликов"
        : reportType === "wa"
        ? "о откликах отправленных в мессенджер"
        : "о откликах отправленных на почту";
    const start = startDate
      ? ` с ${startTime} ${startDate}`
      : " с самого начала";
    const end = endDate ? ` по ${endTime} ${endDate}` : " по настоящее время:";
    return "Отчёт " + type + isInk + start + end;
  };

  function resetInputs() {
    setInk(NaN);
    setStartDate(null);
    setEndDate(null);
    setStartTime("00:00");
    setEndTime("23:59");
    SetNeedEnd(false);
    SetNeedStart(false);
  }

  const createSendedReport = (data) => {
    const heading = createHeading();
    const { total, agg, src, responds } = data;

    if (!total) {
      SetPopupOpened(true);
      return (
        <div className="report">
          <h2>{heading}</h2>
          <h3>За выбранный период не было отправлено ни одного отклика</h3>
          <h4>
            Проверьте правильность введенных данных, возможно была допущена
            ошибка
          </h4>
        </div>
      );
    }
    const h2 = `Всего отправлено ${total} откликов. По вакансиям:`;
    const warn =
      "Внимание! Отчёт может содержать отклики которые отправляются только с авито, но по факту пришли из других источников. Такие отклики клиентам не отправлялись, но могут быть в отчете из-за единой системы хранения данных.";
    const vacsData = Object.entries(agg).map((i) => `${i[0]}: ${i[1]}`);
    const sources =
      Object.keys(src).length === 1
        ? `Все отклики пришли из ${Object.keys(src)[0]}`
        : `${Object.entries(src)
            .map((i) => `${i[1]} откликов из ${i[0]}`)
            .join(", ")
            .replace(/,$/, " и")}`;
    const h3 = "Детально: ";
    const details = responds.map((resp) => (
      <ul>
        {Object.entries(resp).map((i) => (
          <li>{`\t${i[0]}: ${i[1]}\n`}</li>
        ))}
      </ul>
    ));
    SetPopupOpened(true);
    return (
      <div className="report">
        <h2>{heading}</h2>
        <h3>{h2}</h3>
        <h4>{warn}</h4>
        {vacsData.map((i, ind) => (
          <p key={`vacsData-${ind}`}>{`\t${i}\n`}</p>
        ))}
        <h3>
          {sources}
          <br></br>
          {h3}
        </h3>
        <>{details}</>
      </div>
    );
  };

  const createSrcReport = (data) => {
    const heading = createHeading();
    resetInputs();
    SetPopupOpened(true);
    return (
      <div className="report">
        <h2>{heading}</h2>

        {data.map((str, ind) => (
          <p>{`Из источника "${str.source}" - ${str.count} откликов.`}</p>
        ))}
      </div>
    );
  };

  const createAvitoReport = (data) => {
    const heading = createHeading();
    resetInputs();
    SetPopupOpened(true);
    return (
      <div className="report">
        <h2>{heading}</h2>

        {data.map((str, ind) => (
          <p>{`У менеджера ${str.manager} - ${str.count} откликов.`}</p>
        ))}
      </div>
    );
  };

  async function getReport() {
    if (reportType === "") {
      alert("Не выбран тип отчёта!");
      return;
    }

    if (isNeedSetStart & !startDate) {
      alert("Не установлена дата начала отчета!");
      return;
    }

    if (isNeedSetEnd & !endDate) {
      alert("Не установлена дата окончания отчета!");
      return;
    }

    const data = [];

    if (!MICRO_RESPONDS.includes(reportType)) {
      data.push(ink);

      if (isNeedSetEnd) {
        data.push(`${endDate}T${endTime}:00.000Z`);
      }
    }

    if (isNeedSetStart || reportType === "avito") {
      data.push(`${startDate}T${startTime}:00.000Z`);
    }

    if (MICRO_RESPONDS.includes(reportType)) {
      data.push(`${endDate}T${endTime}:00.000Z`);
    }

    const resp = await api.post(
      reportType === "avito"
        ? E.GET_AVITO_REPORTS
        : E.GET_STATISTIC,
      4,
      reportType === "sources"
        ? { dates: data.filter((i) => !i.includes("null")) }
        : { data: data }
    );

    if (resp.success && resp.data) {
      if (!MICRO_RESPONDS.includes(reportType)) {
        setReportData(resp.data);
      }
      const getReport = () => {
        const res = !MICRO_RESPONDS.includes(reportType)
          ? createSendedReport(resp.data)
          : reportType !== "sources"
          ? createAvitoReport(resp.data)
          : createSrcReport(resp.data);
        return res;
      };
      const rep = getReport();
      setReport(rep);
    }
  }

  useEffect(() => {
    if (isPopupOpened && reportData && reportType) {
      const timestamp = new Date().toISOString().slice(0, 10);

      if (!MICRO_RESPONDS.includes(reportType)) {
        const typeName = reportType === "wa" ? "whatsapp" : "email";
        const filename = `report_${typeName}_${timestamp}.txt`;

        const textContent = formatReportToText(reportData, reportType);
        resetInputs();
        saveFile(textContent, filename);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPopupOpened, reportData, reportType]);

  useEffect(() => {
    if (reportType === "avito") {
      SetNeedEnd(true);
      SetNeedStart(true);
    } else {
      SetNeedEnd(false);
      SetNeedStart(false);
    }
  }, [reportType]);

  return (
    <div className="input_block_admin" style={{ height: "max-content" }}>
      <div className="input_block input_block_admin">
        <strong>Отчётность</strong>
        <select
          defaultValue=""
          onChange={(e) => {
            callReset();
            setReportType(e.target.value);
          }}
        >
          <option value="">Выберите тип отчёта</option>
          <option value="avito">Распределение по avito</option>
          <option value="sources">Распределение по источникам</option>
        </select>
      </div>
      {reportType !== "" ? (
        <>
          {MICRO_RESPONDS.includes(reportType) ? (
            ""
          ) : (
            <input
              type="number"
              placeholder="ИНК"
              value={!isNaN(ink) ? ink : ""}
              onChange={(e) => setInk(e.target.value)}
            />
          )}
          {reportType === "avito" ? (
            <>
              <div className="input_block" style={{ marginBottom: "23px" }}>
                <span>Начиная с:&nbsp;</span>
                <input
                  type="date"
                  value={startDate ? startDate : ""}
                  onChange={(e) => setStartDate(e.target.value)}
                />
                <input
                  type="time"
                  style={{ marginLeft: "4px" }}
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                />
              </div>
              <div className="input_block" style={{ marginBottom: "23px" }}>
                <span>Заканчивая по:&nbsp;</span>
                <input
                  type="date"
                  value={endDate ? endDate : ""}
                  onChange={(e) => setEndDate(e.target.value)}
                />
                <input
                  type="time"
                  style={{ marginLeft: "4px" }}
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                />
              </div>
            </>
          ) : (
            <div className={reportType === "sources" && "inputs_reverse"}>
              <div className="input_block" style={{ marginBottom: "23px" }}>
                <input
                  type="checkbox"
                  style={{ marginRight: "5px", background: "#fff" }}
                  checked={isNeedSetEnd}
                  onChange={(e) => SetNeedEnd(e.target.checked)}
                  id="isNeedSetEnd"
                />
                <label htmlFor="isNeedSetEnd">Указывать конечную дату</label>
                {isNeedSetEnd ? (
                  <>
                    <input
                      type="date"
                      value={endDate ? endDate : ""}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                    <input
                      type="time"
                      style={{ marginLeft: "4px" }}
                      value={endTime ? endTime : ""}
                      onChange={(e) => setEndTime(e.target.value)}
                    />
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="input_block" style={{ marginBottom: "23px" }}>
                <input
                  type="checkbox"
                  style={{ marginRight: "5px", background: "#fff" }}
                  checked={isNeedSetStart}
                  onChange={(e) => SetNeedStart(e.target.checked)}
                  id="isNeedSetStart"
                />
                <label htmlFor="isNeedSetStart">Указывать начальную дату</label>
                {isNeedSetStart ? (
                  <>
                    <input
                      type="date"
                      value={startDate ? startDate : ""}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                    <input
                      type="time"
                      style={{ marginLeft: "4px" }}
                      value={startTime ? startTime : ""}
                      onChange={(e) => setStartTime(e.target.value)}
                    />
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
          <button className="report_button" onClick={getReport}>
            Запросить &gt;
          </button>
        </>
      ) : (
        ""
      )}
      {isPopupOpened ? (
        <div
          className="overlay"
          onClick={(e) => {
            if (e.target.className === "overlay") {
              SetPopupOpened(false);
            }
          }}
        >
          {report}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Reports;
